import { FunctionComponent, Suspense, useEffect } from 'react';
import { DraftDesignConfiguration } from '@/types';
import { t } from '@/utils/i18n';
import { lazyWithPreload } from '@/utils/lazyWithPreload';
import { Button } from '@/components/common/Button';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import { CheckMark } from '@/components/common/icons/CheckMark';
import { Modal, ModalHeader, ModalTitle, ModalTypes } from '@/components/common/modal/modal';

const [LazyImageEdit, preload] = lazyWithPreload(
  () => import(/* webpackChunkName: 'image-edit-dialog' */ './ImageEdit')
);

interface AsyncImageEditDialogProps {
  configuration: DraftDesignConfiguration;
  open: boolean;
  onClose: () => void;
  isMaskAvailable: boolean;
  isFilterAvailable: boolean;
}

export const AsyncImageEditDialog: FunctionComponent<AsyncImageEditDialogProps> = ({
  configuration,
  open,
  onClose,
  isMaskAvailable,
  isFilterAvailable,
}) => {
  const title = t('image.edit.title');
  useEffect(() => {
    preload();
  }, []);

  return (
    <Modal type={ModalTypes.panel} title={title} open={open}>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <Suspense fallback={<LoadingOverlay />}>
        <LazyImageEdit
          configuration={configuration}
          isMaskAvailable={isMaskAvailable}
          isFilterAvailable={isFilterAvailable}
        />
        <Button className="image-edit__close" onClick={onClose} small>
          <CheckMark className="image-edit__close-icon" />
          {t('general.close_mobile')}
        </Button>
      </Suspense>
    </Modal>
  );
};
